import { useQuery } from '@apollo/client';
import { FETCH_POLICY_CONFIG, FILTER_IDENTIFIERS } from '../../common/constants/constants';
import { ENTITY_CONSTANTS } from '../../common/constants/entityConstants';
import { searchClient, slimResultsQuery } from '../../common/list/slimQuery';

/**
 * Load production activity data for a given productionId and owner account.
 * Returns the activity data, loading/error states, and a refetch function
 * to manually refresh the query when needed (e.g., after creating/updating activities).
 */
export const useProductionActivityData = (productionId: string, activeOrganizationAccount: string) => {
    const {
        data: activityData,
        loading,
        error,
        refetch
    } = useQuery(slimResultsQuery(ENTITY_CONSTANTS.activity), {
        variables: {
            filters: [
                { identifier: FILTER_IDENTIFIERS.entity, value: ENTITY_CONSTANTS.activity },
                { identifier: FILTER_IDENTIFIERS.production, value: productionId }
            ],
            page: { size: 1000, from: 0 }
        },
        context: {
            headers: { ownerId: activeOrganizationAccount }
        },
        client: searchClient,
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy,
        notifyOnNetworkStatusChange: true,
        skip: !productionId
    });

    return { activityData, loading, error, refetch };
};
